import styled from 'styled-components';

export const Container = styled.div`
  background: #ffffffb2;
  padding: 20px 25px;
  border-radius: 24px;
  border: 1px solid #e2e8f099;
  box-shadow:
    0px 8px 10px -6px #0000001a,
    0px 20px 25px -5px #0000001a;
  width: 100%;

  input#employee-select + div,
  input#department-select + div {
    display: none !important;
  }
`;

export const Title = styled.h2`
  font-size: 25px;
  font-weight: 700;
  color: #212529;
  margin: 0 0 8px 0;
`;

export const Subtitle = styled.p`
  font-size: 16px;
  color: #4a5565;
  margin-bottom: 25px;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 388px);
  column-gap: 20px;

  &.three-columns {
    grid-template-columns: 1fr 1fr 1fr;
    > div > div {
      min-height: auto;
      input {
        background: transparent;
      }
    }
  }
  &.form-currency {
    grid-template-columns: 1fr;
    margin-bottom: 16px;
  }

  @media (max-width: 820px) {
    grid-template-columns: 388px;
    justify-content: center;
  }

  @media (max-width: 420px) {
    grid-template-columns: 1fr;
    padding: 0 10px;
  }
`;

export const FormGroup = styled.div`
  width: 100%;
  margin-top: 10px;

  & > div {
    margin-bottom: 0;
    width: 100% !important;
  }

  .css-b62m3t-container {
    width: 100%;
  }
  &.form-kpi {
    width: 388px;
    margin-top: 12px;
  }
  &.form-max-width {
    max-width: 235px;
    > div {
      min-height: auto;
    }
    > div > div > div {
      background: transparent;
    }
    .css-1jkdxz1-menu {
      background: white;
    }
  }
  .cQoybH:first-of-type {
    display: none;
  }
`;
export const SelectedEmployeesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;

export const EmployeePill = styled.div`
  background: #e8effc;
  color: #2d6cdf;
  padding: 4px 7px;
  border-radius: 16px;
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const RemoveButton = styled.div`
  cursor: pointer;
  font-size: 12px;
  color: #2d6cdf;
  &:hover {
    color: #1e40af;
  }
`;

export const SelectedCount = styled.div`
  margin-top: 32px;
  color: #64748b;
  font-size: 14px;
`;
export const EmployeesLabel = styled.p`
  font-weight: 600;
  font-size: 13px;
  color: #212529;
  margin-bottom: 5px;
  &.duration {
    margin-bottom: 0;
  }
`;
export const KpiContainer = styled.div`
  background: #f0fdf4;
  padding: 17px;
  border-radius: 10px;
  border: 1px solid #f0fdf4;
  max-width: 773px;
`;

export const KpiHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;

export const KpiIcon = styled.span`
  font-size: 20px;
  font-weight: bold;
  color: #15c7a7;
  &.kpiIconQuantity {
    color: #101828;
  }
`;

export const KpiTitle = styled.span`
  font-weight: 600;
  color: #101828;
  font-size: 18px;
`;
export const QuantityContainer = styled.div`
  background: #e3ecfa;
  padding: 17px;
  border-radius: 10px;
  margin-bottom: 20px;
  max-width: 773px;
`;
export const CompensationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 374px);
  gap: 24px;

  @media (max-width: 800px) {
    grid-template-columns: 1fr;
  }
`;

export const CompCard = styled.div`
  width: 374px;
  padding: 17px;
  border-radius: 10px;
  background: ${(props) => props.$bgColor || '#fff'};
  border: 1px solid ${(props) => props.$borderColor || '#eee'};
  box-sizing: border-box;
  > div {
    min-height: auto;
    input {
      background: transparent;
    }
  }
  background-color: ${(props) => {
    switch (props.$variant) {
      case 'danger':
        return '#E639461A';
      case 'warning':
        return '#FFF7ED';
      case 'success':
        return '#F0FDF4';
      case 'info':
        return '#8B5CF61A';
      default:
        return '#fff';
    }
  }};
  border-color: ${(props) => {
    switch (props.$variant) {
      case 'danger':
        return '#FFC9C966';
      case 'warning':
        return '#FFD6A8';
      case 'success':
        return '#15C7A71A';
      case 'info':
        return '#9810FA1A';
      default:
        return '#eee';
    }
  }};
`;
export const CompCardSpan = styled.span`
  font-size: 12px;
  color: #4a5565;
  margin-top: 4px;
  display: block;
`;
export const CompDescription = styled.p`
  font-size: 12px;
  color: #4a5565;
  margin-top: 5px;
`;
export const SummaryContainer = styled.div`
  margin-top: 40px;
`;

export const SummaryLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  margin-bottom: 8px;
`;

export const SummaryRow = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  flex-wrap: wrap;
`;

export const SummaryText = styled.span`
  font-size: 12px;
  color: #6c757d;
`;
export const ErrorForInputs = styled.div`
  display: flex;
  align-items: first baseline;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 4px;
  width: 100%;
`;
export const AlertIcon = styled.img``;
export const ErrorMessage = styled.p`
  color: #e63946;
  font-weight: 600;
  font-size: 12px;
  margin: 0;
  line-height: 1;
`;
export const LabelSelect = styled.p`
  font-weight: 600;
  font-size: 13px;
  color: #212529;
  margin-bottom: 2px;
`;

export const Container1 = styled.div`
  background: #ffffffb2;
  padding: 20px 25px;
  border-radius: 24px;

  border: 1px solid #e2e8f099;
  box-shadow:
    0px 8px 10px -6px #0000001a,
    0px 20px 25px -5px #0000001a;

  input#employee-select + div,
  input#department-select + div {
    display: none !important;
  }
`;
